import { render, staticRenderFns } from "./ActionCard.vue?vue&type=template&id=1b3c3254&scoped=true&"
import script from "./ActionCard.ts?vue&type=script&lang=js&"
export * from "./ActionCard.ts?vue&type=script&lang=js&"
import style0 from "./ActionCard.vue?vue&type=style&index=0&id=1b3c3254&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c3254",
  null
  
)

export default component.exports